import React, { useState } from "react";
import { Container, Paper, Typography } from "@material-ui/core";

import { useStyles } from "../../assets/styles";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import AddStore from "./AddStore";
import EditStore from "./EditStore";
import DeleteStore from "./DeleteStore";

function Restaurants() {
	const [nav, setNav] = useState("");

	const returnNav = () => setNav("");
	const classes = useStyles();
	if (nav === "Add") {
		return <AddStore returnNav={returnNav} />;
	}
	if (nav === "Edit") {
		return <EditStore returnNav={returnNav} />;
	}
	if (nav === "Delete") {
		return <DeleteStore returnNav={returnNav} />;
	}
	return (
		<Container className={classes.root}>
			<Paper className={classes.paper}>
				<Typography variant="h4">Restaurantes</Typography>
				<ButtonWithStyle onClick={() => setNav("Add")}>Agregar</ButtonWithStyle>
				<ButtonWithStyle onClick={() => setNav("Edit")}>Editar</ButtonWithStyle>
				<ButtonWithStyle onClick={() => setNav("Delete")}>Borrar</ButtonWithStyle>
			</Paper>
		</Container>
	);
}

export default Restaurants;
